import type { AnyCalculatorDefinition } from '@/types/calculator'
import { bondDefinition } from './bond/definition'
import { carAffordabilityDefinition } from './car-affordability/definition'
import { fuelCostDefinition } from './fuel-cost/definition'
import { markupProfitDefinition } from './markup-profit/definition'
import { payeDefinition } from './paye/definition'
import { rentalYieldDefinition } from './rental-yield/definition'
import { salaryIncreaseDefinition } from './salary-increase/definition'
import { solarRoiDefinition } from './solar-roi/definition'
import { transferCostDefinition } from './transfer-cost/definition'
import { vatDefinition } from './vat/definition'

export const registry: AnyCalculatorDefinition[] = [
  payeDefinition,
  salaryIncreaseDefinition,
  fuelCostDefinition,
  vatDefinition,
  markupProfitDefinition,
  bondDefinition,
  transferCostDefinition,
  solarRoiDefinition,
  carAffordabilityDefinition,
  rentalYieldDefinition,
].map((c) => c as unknown as AnyCalculatorDefinition)

export function getCalculatorBySlug(slug: string): AnyCalculatorDefinition | undefined {
  return registry.find((c) => c.slug === slug)
}

export const categories = [
  { id: 'salary', label: 'Salary & Tax', icon: 'briefcase' as const },
  { id: 'vehicle', label: 'Vehicle', icon: 'car' as const },
  { id: 'home', label: 'Home & Property', icon: 'home' as const },
  { id: 'business', label: 'Business', icon: 'chart-bar' as const },
  { id: 'energy', label: 'Energy', icon: 'sun' as const },
] as const
